import { GetInferredFromRaw } from '@thinknimble/tn-models'
import { z } from 'zod'

export const guestShape = {
  id: z.string().uuid(),
  created: z.string().datetime({ offset: true }).readonly(),
  lastEdited: z.string().datetime({ offset: true }).readonly(),
  firstName: z.string().max(255),
  lastName: z.string().max(255),
  email: z.string().email().max(254).nullable().optional(),
  phoneNumber: z.string().nullable().optional(),
}

export const guestCreateOutputShape = {
  id: z.string().uuid().readonly(),
  created: z.string().datetime({ offset: true }).readonly(),
  lastEdited: z.string().datetime({ offset: true }).readonly(),
  firstName: z.string().max(255),
  lastName: z.string().max(255),
  email: z.string().email().max(254).nullable().optional(),
  phoneNumber: z.string().nullable().optional(),
}

export const guestCreateInputShape = {
  firstName: z.string().min(1).max(255),
  lastName: z.string().min(1).max(255),
  email: z.string().email().max(254).nullable().optional(),
  phoneNumber: z.string().nullable().optional(),
}

export type GuestShape = GetInferredFromRaw<typeof guestShape>
export type GuestCreateOutputShape = GetInferredFromRaw<typeof guestCreateOutputShape>
export type GuestRequestCreateInputShape = GetInferredFromRaw<typeof guestCreateInputShape>
